import React from 'react';
import ChevronIcon from 'reusable-components/icons/fullcolor/ChevronIcon';
import HelloHelper from 'utils/HelloHelper';
import RoundedAvatar from '~/reusable-components/avatars/RoundedAvatar';

const CSS = require('./FormHeader.module.scss');

interface FormHeaderProps {
  hostImage: string;
  hostName: string;
  hostCountry?: string;
  enabledForm: 'personalized-offer';
  onBack?: () => void;
}

function FormHeader({
  hostImage,
  hostName,
  hostCountry,
  enabledForm,
  onBack,
}: FormHeaderProps) {
  const HelloGreet = HelloHelper.getHelloGreet(hostCountry);

  return (
    <div className={CSS.Container}>
      {onBack && (
        <button onClick={onBack} className={CSS.BackButton}>
          <ChevronIcon
            height={14}
            width={14}
            className={CSS.BackButtonIcon}
            direction="left"
          />
        </button>
      )}
      <header className={CSS.FormHeader}>
        <RoundedAvatar image={hostImage} color="yellow" size={72} />
        <div className={CSS.ContactHostContent} key={enabledForm}>
          <h1 className={CSS.Title}>
            {HelloGreet}, I am {hostName}!
          </h1>
          <p className={CSS.Paragraph}>
            Thanks for getting in touch.
            <br />
            {enabledForm === 'personalized-offer' &&
              "Let's personalize your experience!"}
          </p>
        </div>
      </header>
    </div>
  );
}

export default FormHeader;
